module.exports = __webpack_public_path__ + "img/CLS-P-190.49424ece.svg";